export default {
  SET_PUBLISHING_STATUS: 'SET_PUBLISHING_STATUS',
};
